import React, { useContext } from 'react'
import { useStickyResult } from '../../useStickyResult'
import { pluralizeString } from 'app/ProductShop/pluralizeString'
import { useTranslation } from 'utils/useTranslation'

export function FilterResults({ productCount, isFiltered, clearFilters, context }) {
  const {
    currentVariant,
    isAccessoryShop
  } = useContext(context)

  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const modelName = currentVariant?.name ?? ''

  productCount = isFiltered ? productCount : accessoryStrings.show_product_option.all
  productCount = useStickyResult(productCount)

  return (
    <div className='mtt-filter__results'>
      <div className='mtt-filter__results-show-all mtt-filter__result'>
        {pluralizeString(
          accessoryStrings.show_product_option.showing,
          productCount,
          accessoryStrings.show_product_option.product,
          accessoryStrings.show_product_option.products,
          accessoryStrings.show_product_option.products
        )}
      </div>
      {(isAccessoryShop || modelName === '') ? null : <div className='mtt-filter__results-show-all mtt-filter__result'>{modelName}</div>}

      {isFiltered ? (
        <div
          className='mtt-filter__results-remove-all mtt-filter__result'
          onClick={() => {
            clearFilters()
          }}
        >
          {accessoryStrings.remove_all}
        </div>
      ) : null}
    </div>
  )
}
